import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { Message } from "element-ui"; // 导入 Message
import "./assets/iconfont.css";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
// 移动端访问 PC 站 -> 跳转到同域 wap 子域（a.com -> wap.a.com）
import { redirectMobileToWap } from "./utils/mobile";
dayjs.extend(utc)
dayjs.extend(timezone)
// 服务器时间统一按美国东部时区解析
dayjs.tz.setDefault('America/New_York')
Vue.prototype.$dayjs = dayjs
// import * as echarts from 'echarts'
// Vue.prototype.$echarts = echarts

// 全局挂载 Message 到 Vue 原型
Vue.prototype.$message = Message;

Vue.config.productionTip = false;
Vue.use(ElementUI);

//api
import api from "./api";
Vue.prototype.$api = api;

//i18n
import i18n from "./locales";

// 移动端访问 PC 站：直接跳到 wap 子域，跳转中则不再挂载 PC 应用（避免无谓渲染/请求）
const redirecting = redirectMobileToWap();

if (!redirecting) {
  new Vue({
    router,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
}
